/*>
* @license
* Copyright (c) 2014-2022 ABILITY Network, Inc., an INOVALON, Inc. company. All Rights Reserved.
* 
* This computer program is CONFIDENTIAL and a TRADE SECRET of ABILITY Network, Inc.
* The receipt or possession of this program does not convey any rights to use,
* reproduce or disclose its contents in whole or in part, without the specific
* written consent of ABILITY Network, Inc. Any use, reproduction or disclosure of
* this program without the express written consent of ABILITY Network, Inc. is a
* violation of the copyright laws and may subject you to criminal prosecution.
<*/
import { when } from 'jquery'
import { observer } from 'mobx-react'
import React from 'react'
import { Link, Route, RouteComponentProps } from 'react-router-dom'
import { container, injectProperty } from '../../../configuration/ServiceLocator'
import { SettingsManager } from '../../../configuration/SettingsManager'
import { IArticleInfo, IProductContentStateManager, IProductInfo, ISectionInfo } from '../../../services/ProductContentStateManager/contracts'
import { UserEventLogger } from '../../../utils/UserEventLogger'

export interface IProductContentState {
	productContent: IProductInfo
}

export interface IProductContentProps extends RouteComponentProps {
	productContentStateManager: IProductContentStateManager
	productCode: string
}

@observer
export default class ProductContent extends React.Component<any, IProductContentState> {
	constructor(prop: Readonly<any>) {
		super(prop)
	}
	componentDidMount() {
		this.props.productContentStateManager.getProductInfoByProductCode(this.props.productCode).catch((error: any) => {
			alert(error)
		})
	}
	componentDidUpdate(prevProductCode: any) {
		if (this.props.productCode != prevProductCode.productCode) {
			this.props.productContentStateManager.getProductInfoByProductCode(this.props.productCode).catch((error: any) => {
				alert(error)
			})
		}
	}
	onArticleChange(contentItemId: any) {
		this.props.loadContentInformation(contentItemId)
	}
	onSectionChange(event: any, sectionId: any, sectionName: string) {
		UserEventLogger.handleUserClickEvent(event, 'SupportSite - Product Content Page More Articles Link Click', '')
		this.props.loadSectionInformation(sectionId, sectionName)
	}

	handleArticleLinkClick(event: any, isPdf: boolean) {
		if (isPdf) {
			UserEventLogger.handleUserClickEvent(event, 'SupportSite - Product Content Page Article PDF Link Click', '')
		} else {
			UserEventLogger.handleUserClickEvent(event, 'SupportSite - Product Content Page Article Link Click', '')
		}
	}

	render() {
		return (
			<div>
				<div className="product-description-div product-description">
					<span className="prod-header">{this.props.productName}</span>
					<div className="accordion__text" dangerouslySetInnerHTML={{ __html: this.props.productContentStateManager.productInfo.productDescription }} />
				</div>
				<div className="product-page-main-div-row">
					{this.props.productContentStateManager.productInfo.sectionList.map((section: any, sectionindex: number) => {
						return (
							<div key={sectionindex} className="col-md-5">
								<div className="section-name">{section.sectionName}</div>
								{section.articleList.map((article: any, articleindex: number) => {
									return (
										<div className="product-page-main-div-row article-link-product" key={articleindex}>
											{articleindex < 3 ? (
												// <Link className="word-brak-a" onClick={e => this.onArticleChange(article.path)} to="#">
												// 	{' '}
												// 	{article.displayText}
												// </Link>
												article.IsPdf ? (
													<a
														target="_blank"
														className="word-brak-a"
														href={`${SettingsManager.REACT_APP_MAIN_CMS_BASE_URL().value}` + article.path}
														onClick={e => {
															this.handleArticleLinkClick(e, true)
														}}
													>
														{' '}
														{article.displayText}
													</a>
												) : (
													<Link
														className="word-brak-a"
														to={'/help/pages/' + article.path}
														onClick={e => {
															this.handleArticleLinkClick(e, false)
														}}
													>
														{' '}
														{article.displayText}
													</Link>
												)
											) : articleindex > 3 ? (
												false
											) : (
												<Link className="moreArticles" onClick={e => this.onSectionChange(e, section.sectionId, section.sectionName)} to="#">
													More Articles . . .
												</Link>
											)}
										</div>
									)
								})}
							</div>
						)
					})}
				</div>
			</div>
		)
	}
}
